const DIALOG_SELECTOR = '[role="dialog"]';

/**
 * Tells whether a modal dialog is on screen, so a component can defer a focus move instead of pulling the
 * user out of a dialog's focus trap.
 *
 * Presence in the DOM is not the enough because rio's dialogs stay mounted after they close, and can remain on the DOM
 * with `display: none` for the rest of the session(the release notes dialog for eg.). The computed `display` is read
 * rather than the element's box, because a jsdom test has no layout and every box there measures zero.
 *
 * @param ignored A dialog that does should be ignored by this check.
 */
export const hasOpenDialog = (ignored?: Element | null): boolean =>
  Array.from(document.querySelectorAll(DIALOG_SELECTOR)).some((dialog) => {
    if (dialog === ignored) return false;

    const { display, visibility } = window.getComputedStyle(dialog);
    return display !== 'none' && visibility !== 'hidden';
  });
